'use strict';
var foreach = require('../utils/foreach'),
    isArray = require('../utils/is-array');

/**
 * An array-like class that bind some methods of the contained components
 *
 * The methods list is:
 *  - ['set', 'detach', 'detachComponents', 'render', 'remove', 'removeComponents', 'get']
 *
 * @constructor
 */
function ComponentList() {
}

ComponentList.prototype = [];

foreach(['detach', 'detachComponents', 'render', 'remove', 'removeComponents', 'get'], function (method) {
    /**
     * The binding to the method that collect all the results returned by contained components
     *
     * @returns {Array}
     */
    ComponentList.prototype[method] = function binding() {
        var result = [],
            i,
            l;

        for (i = 0, l = this.length; i < l; i++) {
            if (this[i][method]) {
                result.push(this[i][method].apply(this[i], arguments));
            }
        }

        return result;
    };
});

/**
 * The binding to the setter method
 *
 * @param {*} value
 * @returns {Array}
 */
ComponentList.prototype.set = function setter(value) {
    var result = [],
        i,
        l;

    if (isArray(value)) {
        for (i = 0, l = value.length; i < l; i++) {
            if (this[i] && this[i].set) {
                result.push(this[i].set.call(this[i], value[i]));
            }
        }
    } else {
        for (i = 0, l = this.length; i < l; i++) {
            if (this[i].set) {
                result.push(this[i].set.apply(this[i], arguments));
            }
        }
    }

    return result;
};

module.exports = ComponentList;
